import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { ConfigProvider } from 'antd'
import fa_IR from 'antd/lib/locale/fa_IR'
import { ReactNode } from 'react'

export const AntdProvider = (props: { children: ReactNode }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: colors.PRIMARY,
          fontFamily: 'IRANSans',
        },
      }}
      direction='rtl'
      locale={fa_IR}
    >
      {props.children}
    </ConfigProvider>
  )
}
